import { WorkspacePremium } from '@mui/icons-material';
import { useTheme } from '@mui/material';

export const Challenge = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <WorkspacePremium
      fontSize={size}
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
